import { GenericEventsRouteProvider } from '@wix/data-tools-generic-events';
import { GoalIntentGrid } from './GoalIntentGrid';
import { ScrollArea } from '../ui';
import { AgentsIslandBadge, useAgentsPillReady } from '../AgentsIslandBadge';
import { useChipSlotHolds } from '../chip-morph/ChipSlotContext';
import styles from './EmptyDashboard.module.css';

/**
 * The catch-up home with nothing on it yet: the "What's your goal?" picker. Native parity —
 * `GoalIntentGrid.swift` / `GoalIntentGrid.kt`, from a catalog pinned to this one by
 * `native-apps/shared/goal-intents/briefs.json`.
 *
 * It carries the agents island at the top start, like every other home.
 */
/** `page`: the BI page the grid's clicks report under — the home it stands in for. */
export function EmptyDashboard({ page }: { page?: string } = {}) {
  const pillReady = useAgentsPillReady();
  // While a minimized call owns the shared capsule the pill is not here, but the row keeps its height.
  const pillHere = useChipSlotHolds('pill');
  const reserving = pillReady && !pillHere;
  return (
    <ScrollArea className={styles.root}>
      <div className={styles.track}>
        <div className={`${styles.islandRow}${reserving ? ` ${styles.islandRowReserved}` : ''}`}>
          {reserving ? null : (
            <GenericEventsRouteProvider value="agents-island">
              <AgentsIslandBadge side="start" />
            </GenericEventsRouteProvider>
          )}
        </div>
        <div className={styles.intro}>
          <GoalIntentGrid page={page} />
        </div>
      </div>
    </ScrollArea>
  );
}
